/* AVISE-ME QUANDO CHEGAR (19/10/2026) — ver snippets/tp-avise-me.liquid.
   API usada pelas telas de compra (buy-buttons, Oferta B, caixas de lançamento, kit, compra rápida):
     tpAviseMe.rotulo(variantId)       -> texto do botão para uma variante esgotada
     tpAviseMe.abrir({ variantId, item, botao, rotuloEl })
   Depois de inscrever dispara 'tp-avise-me:feito' no document ({ detail: { variantId } }). */
(function () {
  if (window.tpAviseMe) return;
  var cfg = {};
  try { cfg = JSON.parse(document.getElementById('tp-avise-me-config').textContent); } catch (e) {}
  var ROTULO = 'Avise-me quando chegar';
  var ROTULO_FEITO = 'Pronto! Você será avisada';
  var CHAVE = 'tp-avise-me';

  function feitos() { try { return JSON.parse(localStorage.getItem(CHAVE) || '{}') || {}; } catch (e) { return {}; } }
  function marca(id) { try { var f = feitos(); f[String(id)] = Date.now(); localStorage.setItem(CHAVE, JSON.stringify(f)); } catch (e) {} }
  function jaPediu(id) { return !!feitos()[String(id)]; }

  function api(caminho, corpo) {
    return fetch('https://a.klaviyo.com/client/' + caminho + '/?company_id=' + encodeURIComponent(cfg.companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(corpo)
    });
  }
  // inscrição de volta ao estoque: é ela que coloca a cliente no flow do Klaviyo
  function inscreverEstoque(email, variantId) {
    return api('back-in-stock-subscriptions', { data: {
      type: 'back-in-stock-subscription',
      attributes: { channels: ['EMAIL'], profile: { data: { type: 'profile', attributes: { email: email } } } },
      relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } } }
    } }).then(function (r) {
      if (r.ok) return true;
      var e = new Error('klaviyo ' + r.status); e.status = r.status; throw e;
    });
  }
  // consentimento de marketing (só no pop-up, onde o texto de aceite aparece)
  function inscreverMarketing(email) {
    if (!cfg.lista) return Promise.resolve();
    return api('subscriptions', { data: {
      type: 'subscription',
      attributes: { custom_source: cfg.fonte || 'Avise-me - Site', profile: { data: { type: 'profile', attributes: { email: email } } } },
      relationships: { list: { data: { type: 'list', id: cfg.lista } } }
    } }).catch(function () {});
  }
  function identifica(email) { try { if (window.klaviyo && window.klaviyo.push) window.klaviyo.push(['identify', { $email: email }]); } catch (e) {} }
  function avisa(id) { marca(id); document.dispatchEvent(new CustomEvent('tp-avise-me:feito', { detail: { variantId: String(id) } })); }

  /* ---------- pop-up ---------- */
  var raiz = document.querySelector('[data-tp-am]');
  var atual = null, focoAntes = null;
  function q(s) { return raiz.querySelector(s); }
  function passo(nome) { [].forEach.call(raiz.querySelectorAll('[data-tp-am-passo]'), function (el) { el.hidden = el.getAttribute('data-tp-am-passo') !== nome; }); }
  function erro(msg) { var el = q('[data-tp-am-erro]'); el.textContent = msg || ''; el.hidden = !msg; }
  function fechar() {
    if (!raiz || raiz.hidden) return;
    raiz.hidden = true; document.documentElement.classList.remove('tp-am-aberto');
    if (focoAntes && focoAntes.focus) try { focoAntes.focus(); } catch (e) {}
  }
  function abrirPopup(o) {
    atual = o; focoAntes = document.activeElement;
    [].forEach.call(raiz.querySelectorAll('[data-tp-am-item]'), function (el) { el.textContent = o.item || 'esse tamanho'; });
    erro(''); passo('form');
    var campo = q('#tp-am-email'), btn = q('[data-tp-am-enviar]');
    btn.disabled = false; btn.textContent = 'Avise-me';
    raiz.hidden = false; document.documentElement.classList.add('tp-am-aberto');
    setTimeout(function () { try { campo.focus({ preventScroll: true }); } catch (e) {} }, 60);
  }
  if (raiz) {
    raiz.addEventListener('click', function (ev) { if (ev.target.closest('[data-tp-am-fechar]')) { ev.preventDefault(); fechar(); } });
    document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') fechar(); });
    q('[data-tp-am-form]').addEventListener('submit', function (ev) {
      ev.preventDefault();
      if (!atual) return;
      var campo = q('#tp-am-email'), email = String(campo.value || '').trim().toLowerCase();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { erro('Confira o seu e-mail.'); campo.focus(); return; }
      erro('');
      var btn = q('[data-tp-am-enviar]'), alvo = atual;
      btn.disabled = true; btn.textContent = 'Enviando...';
      inscreverEstoque(email, alvo.variantId).then(function () {
        return inscreverMarketing(email);
      }).then(function () {
        identifica(email);
        q('[data-tp-am-email]').textContent = email;
        passo('ok');
        avisa(alvo.variantId);
      }).catch(function (e) {
        console.error('[tp-avise-me]', e);
        erro(e && e.status >= 400 && e.status < 500 ? 'Não conseguimos registrar esse e-mail. Confira e tente de novo.' : 'Não deu para registrar agora. Tente de novo em instantes.');
        btn.disabled = false; btn.textContent = 'Avise-me';
      });
    });
  }

  /* ---------- cliente logada: sem pop-up, só a confirmação no próprio botão ---------- */
  function inscreverLogada(o) {
    var el = o.rotuloEl || o.botao;
    if (o.botao && o.botao.classList.contains('is-avise-enviando')) return;
    if (o.botao) o.botao.classList.add('is-avise-enviando');
    if (el) el.textContent = 'Enviando...';
    inscreverEstoque(cfg.email, o.variantId).then(function () {
      avisa(o.variantId);
      if (el) el.textContent = ROTULO_FEITO;
    }).catch(function (e) {
      console.error('[tp-avise-me]', e);
      if (el) el.textContent = 'Não deu agora, toque de novo';
    }).then(function () { if (o.botao) o.botao.classList.remove('is-avise-enviando'); });
  }

  window.tpAviseMe = {
    ROTULO: ROTULO,
    jaPediu: jaPediu,
    logada: !!cfg.email,
    rotulo: function (variantId) { return (cfg.email && jaPediu(variantId)) ? ROTULO_FEITO : ROTULO; },
    abrir: function (o) {
      if (!o || !o.variantId) return;
      if (cfg.email) return inscreverLogada(o);
      if (raiz) abrirPopup(o);
    }
  };
  document.dispatchEvent(new CustomEvent('tp-avise-me:pronto'));

  /* ---------- PDP padrão (snippets/buy-buttons.liquid + product-info.js) ----------
     O product-info.js desliga o botão quando a variante esgota; aqui, depois da troca de variante,
     ele volta a ficar ativo com o texto do avise-me. O clique é interceptado antes do submit. */
  function rotuloDe(btn) { return btn.querySelector('.tp-buy-button__label') || btn.querySelector('span') || btn; }
  function aplicaPadrao(btn, variant) {
    if (!btn) return;
    if (variant && !variant.available) {
      btn.removeAttribute('disabled'); btn.removeAttribute('aria-disabled');
      btn.setAttribute('data-tp-avise', variant.id);
      btn.setAttribute('data-tp-avise-item', (btn.getAttribute('data-tp-avise-produto') || '') + ' (' + variant.title + ')');
      rotuloDe(btn).textContent = window.tpAviseMe.rotulo(variant.id);
    } else if (btn.hasAttribute('data-tp-avise')) {
      btn.removeAttribute('data-tp-avise'); btn.removeAttribute('data-tp-avise-item');
    }
  }
  // PUB_SUB_EVENTS é const global (constants.js): existe no escopo, mas NÃO como window.PUB_SUB_EVENTS
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
      var d = ev && ev.data; if (!d || !d.sectionId) return;
      aplicaPadrao(document.getElementById('ProductSubmitButton-' + d.sectionId), d.variant);
    });
  }
  // logada que já pediu: o botão abre com a confirmação
  [].forEach.call(document.querySelectorAll('button[id^="ProductSubmitButton-"][data-tp-avise]'), function (btn) {
    rotuloDe(btn).textContent = window.tpAviseMe.rotulo(btn.getAttribute('data-tp-avise'));
  });
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('button[id^="ProductSubmitButton-"][data-tp-avise]');
    if (!btn) return;
    ev.preventDefault(); ev.stopImmediatePropagation();
    window.tpAviseMe.abrir({ variantId: btn.getAttribute('data-tp-avise'), item: btn.getAttribute('data-tp-avise-item'), botao: btn, rotuloEl: rotuloDe(btn) });
  }, true);
})();
